<template>
  <HubContainer id="cateringHub">

    <template v-if="moduleActivated.catering">
      <HubSection large icon="icon/hub/transactions.svg"
                  :title="$t('catering.sales')"
                  :description="$t('catering.sales_description')"
                  :buttonAction="goToCateringSales">
      </HubSection>

      <HubSection large icon="icon/hub/customer-accounts.svg"
                  :title="$t('catering.prep')"
                  :description="$t('catering.prep_description')"
                  :buttonAction="goToCateringPrep">
      </HubSection>

      <HubSection large icon="icon/hub/gift-cards.svg"
                  :title="$t('catering.deliveries')"
                  :description="$t('catering.deliveries_description')"
                  :buttonAction="goToCateringDeliveries">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "cateringHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "catering.title";
      this.$store.state.pageIcon = "/icon/nav/inventory.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      isGiftCardActivated() {
        return this.branch && this.branch.loyaltyConfig && this.branch.loyaltyConfig.data && this.branch.loyaltyConfig.data.giftCardActivated;
      },
    },

    methods: {
      goToCateringSales() {
        this.$router.push(this.$router.buildContext("/catering-sales"));
      },
      goToCateringPrep() {
        this.$router.push(this.$router.buildContext("/catering-prep"));
      },
      goToCateringDeliveries() {
        this.$router.push(this.$router.buildContext("/catering-deliveries"));
      },
    }
  }
</script>